// The NCR types the report form offers (utils/CRUDA/non_conformance.tsx).
const NCR_TYPES = [
	{ value: "temporary", label: "Temporary" },
	{ value: "permanent", label: "Permanent" },
];

// Whether a stored NCR type is one the report form offers.
export const isNcrType = (type: unknown): type is string =>
	NCR_TYPES.some((option) => option.value === type);

// How the report form names a stored NCR type; a dash for any other.
export const getNcrTypeLabel = (type: unknown) =>
	NCR_TYPES.find((option) => option.value === type)?.label ?? "—";
